'use strict'

export const kmSettings = {
  XbUrl: 'https://xbuffer.net',
  XbPath: 'client',
  XbUser: 'codingride',
  XbProject: 'website',
  XbDirectory: 'codingride',
  XbProfiles: 'profiles',
  XbAppID: 'bb42a7a45b0f183a8b3e8bca798b756b9ff140231bbe6c59df790fd4a9e95ea8:web'
}
